export const DiscussionType_Chat = 'chat';
export const DiscussionType_GladosIssue = 'glados-issue';
//# sourceMappingURL=consts.js.map